import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
import CartExpress from "../../images/expressOrders.png";
import IndividualExpress from "../../images/expressIndividual.png"

function ExpressOrders() {
  const expressOrdersDoc = {
    title: "Express Orders",
    description: "Learn how to efficiently manage and process express orders, which require expedited processing and shipping.",
    sections: [
      {
        title: "Overview",
        content:
          "Express orders are high-priority orders that necessitate fast tracking through the order process. This feature allows you to identify, filter, and manage express orders effectively.",
      },
      {
        title: "Cart Orders",
        content:
          "The Cart Orders section consists of Active Orders and Finished Orders. Each section provides guidance on how to handle the respective processes.",
        image: CartExpress,
        imageAlt: "Cart Express Dashboard Overview",
        imageCaption: "Figure 1: Comprehensive view of the Express Cart Orders Dashboard",
        subsections: [
          {
            title: "Active Orders",
            content:
              "Filter express orders from the main order list for efficient management.",
            steps: [
              "Use the search button to locate orders by order number (e.g., 1724842874791). Omit 'ORDERGH-' for best results.",
              "Click on ACTIONS on the far right of the order to check status, manage returns, or download invoices.",
              "ORDER DETAILS: View active order specifics and status options (e.g., pending, accepted, supplier notified).",
              "RESELLER INVOICE: Access and print the invoice for the reseller.",
              "CUSTOMER INVOICE: Access and print the invoice for the customer.",
            ],
          },
          {
            title: "Finished Orders",
            content:
              "Ensure express orders are processed swiftly to meet delivery deadlines.",
            steps: [
              "Review finished orders regularly to maintain a timely workflow.",
              "Check for any unresolved issues that may have delayed order completion.",
            ],
            note: "Remember: The efficiency of processing express orders is crucial to maintaining customer satisfaction.",
          },
        ],
      },
      {
        title: "Individual Orders",
        content:
          "The Individual Orders section displays a list of all single orders on the dashboard, along with available actions for each order.",
        image: IndividualExpress,
        imageAlt: "Individual Express Orders Dashboard Overview",
        imageCaption: "Figure 1: Comprehensive view of Individual Express Orders Dashboard",
        subsections: [
          {
            title: "Change Status",
            content: "Modify order status and add notes for tracking purposes.",
            steps: [
              "Search for each order by its ID (e.g., 20247-2811115-663).",
              "Change the order status to options like pending, accepted, etc.",
              "ADD NOTES: Utilize the functionality to add relevant notes for each order.",
              "UPDATE ORDER: Click 'Update Order' to submit any changes made.",
            ],
          },
          {
            title: "Edit Orders",
            content:
              "Ensure express orders are modified swiftly to adhere to delivery deadlines.",
            steps: [
              "EDIT CUSTOMER LOCATION: Click 'Add Location' to update the customer's latest location.",
              "EDIT ORDER NUMBER: Use the plus and minus signs to adjust the quantity of items ordered.",
              "CHANGE DELIVERY LOCATION: Modify the delivery location as needed, noting that it may affect delivery costs.",
              "UPDATE ORDER: Click 'Update Order' to save your changes.",
              "Generate a shipping label using the express shipping option.",
            ],
            note: "Remember: Express orders have a 2-hour processing time target from the moment they are received.",
          },
          {
            title: "More",
            content: "Access additional operations that can be performed on individual orders.",
            steps: [
              "VIEW CART: Check the current cart status.",
              "EDIT SKU: Modify stock-keeping unit details.",
              "ADD NOTES: Include additional notes for reference.",
              "DELIVERY MESSAGE: Add a personalized message for the delivery.",
              "PICKUP MESSAGE: Add instructions or messages for pickups.",
            ],
            note: "Remember: Timely processing of express orders is essential for maintaining customer satisfaction.",
          },
        ],
      },
    ],
  };
  
  return <FeatureDocumentation {...expressOrdersDoc} />;
}

export default ExpressOrders;
